export const SCHEDULE_ADMISSIONS_CHAT_LINK = 'https://calendly.com/quantic-edu/chat';
